"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.verifyAccessPointUnlockRequest = verifyAccessPointUnlockRequest;
var timetable_verification_1 = require("../timetable-verification");
var utils_1 = require("../utils");
var selectAccessPointSchedulesByUserRoles_1 = require("./selectAccessPointSchedulesByUserRoles");
var selectValidAccessPointUserRoles_1 = require("./selectValidAccessPointUserRoles");
function verifyAccessPointUnlockRequest(accessPoint, userRoles) {
    var timezone = accessPoint.property.timezone;
    var validUserRoles = (0, selectValidAccessPointUserRoles_1.selectValidAccessPointUserRoles)(accessPoint, userRoles);
    if (!validUserRoles.length) {
        throw new utils_1.ExposedError('You do not have access to this entry point');
    }
    validUserRoles = userRoles.filter(function (u) { return (!u.schedule || (0, timetable_verification_1.isDateAllowedOnTimetable)(new Date(), u.schedule, timezone)); });
    if (!validUserRoles.length) {
        throw new utils_1.ExposedError('You cannot access this entry point at this time');
    }
    var accessPointSchedules = (0, selectAccessPointSchedulesByUserRoles_1.selectAccessPointSchedulesByUserRoles)(accessPoint, validUserRoles, {
        includeReservationOnly: false,
        excludeBypassedSchedules: true,
    });
    if (accessPointSchedules && !(0, timetable_verification_1.isDateAllowedOnTimetable)(new Date(), accessPointSchedules, timezone)) {
        throw new utils_1.ExposedError('You cannot access this entry point at this time');
    }
    return { validUserRoles: validUserRoles, accessPointSchedules: accessPointSchedules };
}
//# sourceMappingURL=verifyAccessPointUnlockRequest.js.map